import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
import Exercise from "./pages/Exercise";
import Workout from "./pages/Workout";
import Contact from "./pages/Contact";
import NoPage from "./pages/NoPage";
import Login from "./pages/Login";
import ExerciseList from "./pages/ExerciseList";
import WorkoutPlan from "./pages/WorkoutPlan";
import MyWorkoutHistory from "./pages/MyWorkoutHistory";
import MyPersonalDetails from "./pages/MyPersonalDetails";
import 'bootstrap/dist/css/bootstrap.min.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="exercise" element={<Exercise />} />
          <Route path="workout" element={<Workout />} />
          <Route path="contact" element={<Contact />} />
          <Route path="login" element={<Login />} />
          <Route path="exerciselist" element={<ExerciseList />} />
          <Route path="workoutplan" element={<WorkoutPlan />} />
          <Route path="myworkouthistory" element={<MyWorkoutHistory />} />
          <Route path="mypersonaldetails" element={<MyPersonalDetails />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);